<template>
  <v-icon @click="edit = !edit" v-if="isClubManager" color="primary" size="40" >{{ edit ? 'mdi-arrow-u-left-top' : 'mdi-pencil' }}</v-icon>
  <v-icon @click="openCreateDialog" v-if="isClubManager && edit" color="green" size="40">mdi-plus-thick</v-icon>

  <h3 class="mt-3">Aktuální pravidla pro automoduly:</h3>

  <div v-if="Object.keys(actual_rules).length && !edit">
    <v-row>
      <v-col cols="12" md="3">
        <v-list-item>
          <v-list-item-title class="d-inline">Platnost od:</v-list-item-title>
          {{ $formatDate(actual_rules.valid_from) }}
        </v-list-item>
        <v-list-item v-if="actual_rules.description">
          <v-list-item-title class="d-inline">Popis:</v-list-item-title>
          {{ actual_rules.description }}
        </v-list-item>
      </v-col>
      <v-col cols="12" md="3" v-if="actual_rules.automodule_amortization || actual_rules.automodule_petrol_price || actual_rules.automodule_diesel_price || actual_rules.automodule_consumption">
        <h4>Proplácení podle aktuálních cen:</h4>
        <v-list-item v-if="actual_rules.automodule_amortization">
          <v-list-item-title class="d-inline">Amortizace:</v-list-item-title>
          {{ actual_rules.automodule_amortization }} Kč/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_petrol_price">
          <v-list-item-title class="d-inline">Cena za benzín:</v-list-item-title>
          {{ actual_rules.automodule_petrol_price }} Kč/l
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_diesel_price">
          <v-list-item-title class="d-inline">Cena za naftu:</v-list-item-title>
          {{ actual_rules.automodule_diesel_price }} Kč/l
        </v-list-item>

        <v-list-item v-if="actual_rules.automodule_consumption">
          <v-list-item-title class="d-inline">Spotřeba:</v-list-item-title>
          <span v-if="actual_rules.automodule_consumption">
            &nbsp;<v-icon color="green">mdi-check-circle</v-icon> Ano (podle nastavení uživatele)
          </span>
          <span v-else>
            <v-icon color="red">mdi-close-circle</v-icon> Ne
          </span>
        </v-list-item>
      </v-col>
      <v-col cols="12" md="3" v-if="actual_rules.automodule_price_index_1 || actual_rules.automodule_price_index_2 || actual_rules.automodule_price_index_3 || actual_rules.automodule_price_index_4 || actual_rules.automodule_price_index_5 || actual_rules.automodule_price_index_6">
        <h4>Proplácení fixně podle počtu osob:</h4>
        <v-list-item v-if="actual_rules.automodule_price_index_1">
          <v-list-item-title class="d-inline">1 osoba - </v-list-item-title>
          {{ actual_rules.automodule_price_index_1 }} Kč/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_2">
          <v-list-item-title class="d-inline">2 osoby - </v-list-item-title>
          {{ actual_rules.automodule_price_index_2 }} Kč/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_3">
          <v-list-item-title class="d-inline">3 osoby - </v-list-item-title>
          {{ actual_rules.automodule_price_index_3 }} Kč/km 
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_4">
          <v-list-item-title class="d-inline">4 osoby - </v-list-item-title>
          {{ actual_rules.automodule_price_index_4 }} Kč/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_5">
          <v-list-item-title class="d-inline">5 osob - </v-list-item-title>
          {{ actual_rules.automodule_price_index_5 }} Kč/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_6">
          <v-list-item-title class="d-inline">Více než 5 osob - </v-list-item-title>
          {{ actual_rules.automodule_price_index_6 }} Kč/km
        </v-list-item>
      </v-col>

      <v-col cols="12" md="3">
        <v-card color="grey-lighten-5" class="pa-4 mr-1" elevation="3">
          <h4>Proplácení příspěvků za soutěže:</h4>

          <v-list-item>
            <v-list-item-title class="d-inline">Příspěvek na startovné:</v-list-item-title>
            {{ actual_rules.start_fee_contribution }} %
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="d-inline">Příspěvek na ubytování:</v-list-item-title>
            {{ actual_rules.accommodation_contribution }} %
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="d-inline">Příspěvek na stravu:</v-list-item-title>
            {{ actual_rules.food_contribution }} %
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="d-inline">Příspěvek na dopravu:</v-list-item-title>
            {{ actual_rules.automodule_contribution }} %
          </v-list-item>
        </v-card>
      </v-col>



    </v-row>
  </div>

  <div v-else>Žádná pravidla ještě nebyla nastavena.</div>


  <v-form v-if="Object.keys(actual_rules).length && edit" ref="formRef" v-model="formValid" class="mb-5">
    <v-alert type="warning" class="mb-2">Upravujte jen v případě, že jste se při vytvoření spletli. Pokud chceš definovat ZMĚNU hodnot, pak založ nový záznam  <v-icon @click="openCreateDialog" v-if="isClubManager && edit" color="green" size="30">mdi-plus-thick</v-icon>. Starý se uloží a budou se podle něj řídit finance v období jeho platnosti.</v-alert>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="editRules.valid_from"
          label="Platnost od"
          type="date"
          density="comfortable"
          :rules="[
            v => v !== null && v !== '' || 'Musí být vyplněné datum'
          ]"
        />
        <v-textarea
          v-model="editRules.description"
          label="Popis"
          maxlength="80"
          counter
          density="comfortable"
          rows="2"
        />
        <v-text-field
          v-model="editRules.automodule_amortization"
          label="Amortizace"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          min="0"
          step="0.1"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_petrol_price"
          label="Cena benzínu"
          type="number"
          density="comfortable"
          suffix="Kč/l"
          min="0"
          step="0.1"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
          :error="!!fuelConsumptionError"
          :error-messages="fuelConsumptionError"
        />
        
        <v-text-field
          v-model="editRules.automodule_diesel_price"
          label="Cena nafty"
          type="number"
          density="comfortable"
          suffix="Kč/l"
          min="0"
          step="0.1"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
          :error="!!fuelConsumptionError"
          :error-messages="fuelConsumptionError"
        />

        <v-switch
          v-model="editRules.automodule_consumption"
          label="Započítat spotřebu auta"
          density="comfortable"
          class="ml-4"
          suffix="l/100km"
          color="primary"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="editRules.automodule_price_index_1"
          label="Sazba pro 1 osobu"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_2"
          label="Sazba pro 2 osoby"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_3"
          label="Sazba pro 3 osoby"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_4"
          label="Sazba pro 4 osoby"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_5"
          label="Sazba pro 5 osob"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_6"
          label="Sazba pro 6+ osob"
          type="number"
          density="comfortable"
          suffix="Kč/km"
          :rules="[
            v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
          ]"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="editRules.start_fee_contribution"
          label="Proplacení startovného"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || 'Musí zde být číslo od 0 do 100',
            v => (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
          ]"
        />

        <v-text-field
          v-model="editRules.accommodation_contribution"
          label="Proplacení ubytování"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || 'Musí zde být číslo od 0 do 100',
            v => (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
          ]"
        />

        <v-text-field
          v-model="editRules.food_contribution"
          label="Proplacení stravy"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || 'Musí zde být číslo od 0 do 100',
            v => (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
          ]"
        />

        <v-text-field
          v-model="editRules.automodule_contribution"
          label="Proplacení dopravy"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || 'Musí zde být číslo od 0 do 100',
            v => (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
          ]"
        />

      </v-col>

    </v-row>
    <v-alert type="error" v-if="errorMessage" class="my-2">{{ errorMessage }}</v-alert>
    <v-btn @click="submitEditClubPaymentsRules" :disabled="!formValid" color="primary">
      Uložit
    </v-btn>
  </v-form>


  <!-- Dialog pro vytvoření nových pravidel financí oddílu -->
  <v-dialog v-model="createDialog" max-width="1000px">
    <v-card>
      <v-card-title class="text-h5">Vytvoření nových, aktuálních pravidel</v-card-title>
      <v-card-text>
        <v-form ref="formRef" v-model="formValid" class="mb-5">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="newRules.valid_from"
                label="Platnost od"
                type="date"
                density="comfortable"
                :rules="[
                    v => v !== null && v !== '' || 'Musí být vyplněné datum'
                  ]"
              />
              <v-text-field
                v-model="newRules.description"
                label="Popis"
                maxlength="80"
                counter
                density="comfortable"
              />
              <v-text-field
                v-model="newRules.automodule_amortization"
                label="Amortizace"
                type="number"
                density="comfortable"
                suffix="Kč/km"
                min="0"
                step="0.1"
                :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
              />
              <v-text-field
                v-model="newRules.automodule_petrol_price"
                label="Cena za benzín"
                type="number"
                density="comfortable"
                suffix="Kč/l"
                min="0"
                step="0.1"
                :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
                :error="!!fuelConsumptionErrorCreate"
                :error-messages="fuelConsumptionErrorCreate"
              />
                            <v-text-field
                v-model="newRules.automodule_diesel_price"
                label="Cena za naftu"
                type="number"
                density="comfortable"
                suffix="Kč/l"
                min="0"
                step="0.1"
                :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
                :error="!!fuelConsumptionErrorCreate"
                :error-messages="fuelConsumptionErrorCreate"
              />
              <v-switch
                v-model="newRules.automodule_consumption"
                label="Započítat spotřebu auta"
                density="comfortable"
                class="ml-4"
                suffix="l/100km"
                color="primary"
              />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="newRules.automodule_price_index_1"
              label="Sazba pro 1 osobu"
              type="number"
              density="comfortable"
              suffix="Kč/km"
              :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_2"
              label="Sazba pro 2 osoby"
              type="number"
              density="comfortable"
              suffix="Kč/km"
              :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_3"
              label="Sazba pro 3 osoby"
              type="number"
              density="comfortable"
              suffix="Kč/km"
              :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_4"
              label="Sazba pro 4 osoby"
              type="number"
              density="comfortable"
              suffix="Kč/km"
              :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_5"
              label="Sazba pro 5 osob"
              type="number"
              density="comfortable"
              suffix="Kč/km"
              :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_6"
              label="Sazba pro 6+ osob"
              type="number"
              density="comfortable"
              suffix="Kč/km"
              :rules="[
                  v => v === null || v === '' || v >= 0 || 'Hodnota musí být kladná',
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || 'Max. 3 číslice, 1 desetinné místo'
                ]"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="newRules.start_fee_contribution"
              label="Proplacení startovného"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
              ]"
            />

            <v-text-field
              v-model="newRules.accommodation_contribution"
              label="Proplacení ubytování"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
              ]"
            />

            <v-text-field
              v-model="newRules.food_contribution"
              label="Proplacení stravy"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
              ]"
            />

            <v-text-field
              v-model="newRules.automodule_contribution"
              label="Proplacení dopravy"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || 'Hodnota musí být mezi 0 a 100'
              ]"
            />
          </v-col>

        </v-row>
      </v-form>
      <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
      <v-alert type="info" class="my-2" density="compact">Vytvořením se k zadanému datu automaticky ukončí platnost starých pravidel, která ale budou pro jejich staré období stále platit.</v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn color="grey" text @click="createDialog = false">Zrušit</v-btn>
      <v-spacer />
      <v-btn color="green" :disabled="!formValid" @click="submitCreateClubPaymentsRules">Vytvořit</v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>



  <h2>Historie:</h2>
  <v-data-table
    :headers="headers"
    :items="payments_rules"
    :loading="isLoading"
    hide-default-footer
    loading-text="Načítám data..."
    density="compact"
    no-data-text="Nenalezeny žádné záznamy"
    :sort-by="[{ key: 'valid_from', order: 'desc' }]"
    :items-per-page="-1"
    style="white-space: nowrap"
  >
    <template v-slot:[`item.valid_from`]="{ item }">
      {{ $formatDate(item.valid_from) }}
    </template>

    <template v-slot:[`item.valid_to`]="{ item }">
      {{ item.valid_to ? $formatDate(item.valid_to) : '' }}
    </template>

    <template v-slot:[`item.description`]="{ item }">
      <span style="white-space: normal !important; word-break: break-word;">{{ item.description }}</span>
    </template>

    <template v-slot:[`item.automodule_amortization`]="{ item }">
      {{ item.automodule_amortization ? item.automodule_amortization : '--'  }} Kč/km
    </template>

    <template v-slot:[`item.automodule_petrol_price`]="{ item }">
      {{ item.automodule_petrol_price ? item.automodule_petrol_price : '--'  }} Kč/l
    </template>

        <template v-slot:[`item.automodule_diesel_price`]="{ item }">
      {{ item.automodule_diesel_price ? item.automodule_diesel_price : '--'  }} Kč/l
    </template>


    <template v-slot:[`item.automodule_price_index_1`]="{ item }">
      {{ item.automodule_price_index_1 ? item.automodule_price_index_1 : '--'  }} Kč/km
    </template>

    <template v-slot:[`item.automodule_price_index_2`]="{ item }">
      {{ item.automodule_price_index_2 ? item.automodule_price_index_2 : '--' }} Kč/km
    </template>

    <template v-slot:[`item.automodule_price_index_3`]="{ item }">
      {{ item.automodule_price_index_3 ? item.automodule_price_index_3 : '--' }} Kč/km
    </template>

    <template v-slot:[`item.automodule_price_index_4`]="{ item }">
      {{ item.automodule_price_index_4 ? item.automodule_price_index_4 : '--' }} Kč/km
    </template>

    <template v-slot:[`item.automodule_price_index_5`]="{ item }">
      {{ item.automodule_price_index_5 ? item.automodule_price_index_5 : '--' }} Kč/km
    </template>

    <template v-slot:[`item.automodule_price_index_6`]="{ item }">
      {{ item.automodule_price_index_6 ? item.automodule_price_index_6 : '--' }} Kč/km
    </template>

    <template v-slot:[`item.automodule_consumption`]="{ item }">
      <div class="text-center">
        <v-icon v-if="item.automodule_consumption" color="green">mdi-check-circle</v-icon>
        <v-icon v-else color="red">mdi-close-circle</v-icon>
      </div>
    </template>

    <template v-slot:[`item.start_fee_contribution`]="{ item }">
      {{ item.start_fee_contribution }} %
    </template>
    <template v-slot:[`item.accommodation_contribution`]="{ item }">
      {{ item.accommodation_contribution }} %
    </template>
    <template v-slot:[`item.food_contribution`]="{ item }">
      {{ item.food_contribution }} %
    </template>
    <template v-slot:[`item.automodule_contribution`]="{ item }">
      {{ item.automodule_contribution }} %
    </template>

  </v-data-table>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import apiClient from '/api.js'
import { useRoute } from 'vue-router'
import {useSnackbarStore} from '@/stores/snackbarStore'


const props = defineProps({
  activeTab: {
    type: String,
    required: true,
  },
  isClubManager: {
    type: Boolean,
    default: false
  }
})

// Aktivní záložka club_payments_rules
const isTabActive = computed(() => props.activeTab === 'club_payments_rules')
const snackbar = useSnackbarStore()
const route = useRoute()
const club_shortcut = computed(() => route.params.id)
const edit = ref(false);

const isLoading = ref(false)
const payments_rules = ref([])
const actual_rules = ref({})

const fetchPaymentsRules = async () => {
  isLoading.value = true
  try {
    const response = await apiClient.get(`/club/payments_rules/?club_shortcut=${club_shortcut.value}`)
    payments_rules.value = response.data
    actual_rules.value = response.data && response.data.length > 0 ? response.data[0] : {}
  } catch (error) {
    console.error(error)
  } finally {
    isLoading.value = false
  }
}

// Definice hlaviček tabulky se všemi poli z API
const headers = [
  { title: 'Platnost od', value: 'valid_from' },
  { title: 'Platnost do', value: 'valid_to' },
  { title: 'Popis', value: 'description', maxWidth: 180, minWidth: 180 },
  { title: 'Amort.', value: 'automodule_amortization' },
  { title: 'Benzín', value: 'automodule_petrol_price' },
  { title: 'Nafta', value: 'automodule_diesel_price' },
  { title: 'Spotřeba', value: 'automodule_consumption', maxWidth: 80},
  { title: '1 os.', value: 'automodule_price_index_1' },
  { title: '2 os.', value: 'automodule_price_index_2' },
  { title: '3 os.', value: 'automodule_price_index_3' },
  { title: '4 os.', value: 'automodule_price_index_4' },
  { title: '5 os.', value: 'automodule_price_index_5' },
  { title: '> 5 os.', value: 'automodule_price_index_6' },
  { title: 'Startovné', value: 'start_fee_contribution' },
  { title: 'Ubytování', value: 'accommodation_contribution' },
  { title: 'Strava', value: 'food_contribution' },
  { title: 'Doprava', value: 'automodule_contribution' }
]

// Sledujeme, zda je záložka aktivní
watch(isTabActive, (active) => {
  if (active) {
    fetchPaymentsRules()
  }
}, { immediate: true })


const fuelConsumptionError = computed(() => {
  const petrol = editRules.value.automodule_petrol_price
  const diesel = editRules.value.automodule_diesel_price
  const consumption = editRules.value.automodule_consumption

  const petrolEmpty = petrol === null || petrol === '' || Number(petrol) === 0
  const dieselEmpty = diesel === null || diesel === '' || Number(diesel) === 0

  if (consumption && (petrolEmpty || dieselEmpty)) {
    return 'Musíte zadat cenu benzínu i nafty'
  }
  if (!consumption && (!petrolEmpty || !dieselEmpty)) {
    return 'Musíš ještě aktivovat započítání spotřeby auta'
  }
  return ''
})


// Nastavení null hodnot místo "" když se hodnota z formuláře edit a create smaže

const normalizeEmptyToNull = (obj) => {
  const copy = { ...obj };
  Object.keys(copy).forEach((key) => {
    if (copy[key] === "" && key !== 'description') {
      copy[key] = null;
    }
  });
  return copy;
};

const formValid = ref(false)
const errorMessage = ref('')
const editRules = ref({})

const submitEditClubPaymentsRules = async () => {
  try {
    const payload = normalizeEmptyToNull({ ...editRules.value });
    await apiClient.put(`/club/payments_rules/?rule_id=${editRules.value.id}`, payload);

    await fetchPaymentsRules()
    edit.value = false
    snackbar.showSnackbar('Pravidla byla úspěšně aktualizována.')
    errorMessage.value = ''
  } catch (error) {
    const detail = error.response?.data?.error || error.response?.data?.detail || 'Neznámá chyba.';
    errorMessage.value = `Nepodařilo se uložit změny. ${detail}`;
    console.error(error)
  }
}


// Kdykoliv se přepne edit mód na true, zkopíruj aktuální pravidla
watch(edit, (isEditing) => {
  if (isEditing && actual_rules.value) {
    editRules.value = { ...actual_rules.value }
  }
})


const createDialog = ref(false)
const newRules = ref({})
const formRef = ref(null)

const openCreateDialog = () => {
  // inicializace výchozích hodnot
  newRules.value = {
    valid_from: '',
    description: '',
    automodule_amortization: null,
    automodule_petrol_price: null,
    automodule_diesel_price: null,
    automodule_consumption: false,
    automodule_price_index_1: null,
    automodule_price_index_2: null,
    automodule_price_index_3: null,
    automodule_price_index_4: null,
    automodule_price_index_5: null,
    automodule_price_index_6: null,
    automodule_contribution: 0,
    start_fee_contribution: 0,
    accommodation_contribution: 0,
    food_contribution: 0,
  }
  createDialog.value = true
  nextTick(() => formRef.value?.validate())
}

const fuelConsumptionErrorCreate = computed(() => {
  const petrol = newRules.value.automodule_petrol_price
  const diesel = newRules.value.automodule_diesel_price
  const consumption = newRules.value.automodule_consumption

  const petrolEmpty = petrol === null || petrol === '' || Number(petrol) === 0
  const dieselEmpty = diesel === null || diesel === '' || Number(diesel) === 0

  if (consumption && (petrolEmpty || dieselEmpty)) {
    return 'Musíte zadat cenu benzínu i nafty'
  }
  if (!consumption && (!petrolEmpty || !dieselEmpty)) {
    return 'Musíš ještě aktivovat započítání spotřeby auta'
  }
  return ''
})



const submitCreateClubPaymentsRules = async () => {
  try {
    const payload = normalizeEmptyToNull({ ...newRules.value });
    await apiClient.post(`/club/payments_rules/?club_shortcut=${club_shortcut.value}`, payload) 

    await fetchPaymentsRules()
    createDialog.value = false
    snackbar.showSnackbar('Nová pravidla byla úspěšně vytvořena.')
    errorMessage.value = ''
    edit.value = false
  } catch (error) {
    const detail = error.response?.data?.error || error.response?.data?.detail || 'Neznámá chyba.';
    errorMessage.value = `Nové pravidlo se nepodařilo vytvořit. ${detail}`;
    console.error(error)
  }
}


</script>
